<template>
  <b-col class="px-0">
    <b-input-group>
      <b-input-group-prepend>
        <b-button
          v-if="categories.length > 2"
          size="sm"
          variant="outline-danger"
          @click="removeCategory"
        >
          <font-awesome-icon icon="minus" />
        </b-button>
      </b-input-group-prepend>
      <!--
        Using prop anyError instead solves:
        TypeError: Cannot read properties of undefined (reading 'title')
        on remove category
      -->
      <b-input
        :state="!anyError && null"
        :value="title"
        @input="$emit('update:title', $event)"
      />
    </b-input-group>
  </b-col>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  categories: {
    type: Array,
    required: true,
  },
  row: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  anyError: Boolean,
  v: {
    type: Object,
    required: true,
  },
}

@Component
export default class CategoryTitles extends Vue.extend({ props }) {
  removeCategory () {
    this.categories.splice(this.row, 1)
    this.v.$touch()
  }
}

</script>
